document.addEventListener('DOMContentLoaded', () => {
  const root = document.documentElement;
  const allowedViews = ['3', '4', '6'];
  const allowedMobileViews = ['1', '2'];
  const storedView = window.localStorage ? window.localStorage.getItem('mdsView') : null;
  const storedMobileView = window.localStorage ? window.localStorage.getItem('mdsMobileView') : null;
  const defaultButton = document.querySelector('.mds-view-toggle.is-active');
  const defaultView = defaultButton?.dataset.mdsView || '4';
  const initialView = allowedViews.includes(storedView)
    ? storedView
    : allowedViews.includes(defaultView)
      ? defaultView
      : '4';
  const initialMobileView = allowedMobileViews.includes(storedMobileView) ? storedMobileView : '1';

  const updateGridColumns = (view) => {
    document.querySelectorAll('.mds-product-grid').forEach((grid) => {
      Array.from(grid.classList).forEach((className) => {
        if (/^grid--\d+-col-desktop$/.test(className)) {
          grid.classList.remove(className);
        }
      });
      grid.classList.add(`grid--${view}-col-desktop`);
    });
  };

  const applyView = (view) => {
    const resolvedView = allowedViews.includes(view) ? view : defaultView;
    root.setAttribute('data-mds-view', resolvedView);
    document.querySelectorAll('.mds-view-toggle').forEach((button) => {
      const isActive = button.dataset.mdsView === resolvedView;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
    if (window.localStorage) {
      window.localStorage.setItem('mdsView', resolvedView);
    }
    updateGridColumns(resolvedView);
  };

  const applyMobileView = (view) => {
    const resolvedView = allowedMobileViews.includes(view) ? view : '1';
    root.setAttribute('data-mds-mobile-view', resolvedView);
    document.querySelectorAll('.mds-mobile-view-toggle').forEach((button) => {
      const isActive = button.dataset.mdsMobileView === resolvedView;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
    if (window.localStorage) {
      window.localStorage.setItem('mdsMobileView', resolvedView);
    }
    document.querySelectorAll('.mds-product-grid').forEach((grid) => {
      Array.from(grid.classList).forEach((className) => {
        if (/^grid--\d+-col-tablet-down$/.test(className)) {
          grid.classList.remove(className);
        }
      });
      grid.classList.add(`grid--${resolvedView}-col-tablet-down`);
    });
  };

  const closeSortPanels = () => {
    document.querySelectorAll('[data-mds-sort]').forEach((sort) => {
      const panel = sort.querySelector('.mds-sort__panel');
      const toggle = sort.querySelector('[data-mds-sort-toggle]');
      if (panel) panel.hidden = true;
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    });
  };

  const openSortSheet = () => {
    const overlay = document.querySelector('[data-mds-sort-overlay]');
    const sheet = document.querySelector('[data-mds-sort-sheet]');
    if (overlay) {
      requestAnimationFrame(() => overlay.classList.add('is-open'));
    }
    if (sheet) {
      requestAnimationFrame(() => sheet.classList.add('is-open'));
    }
    document.body.style.overflow = 'hidden';
  };

  const closeSortSheet = () => {
    const overlay = document.querySelector('[data-mds-sort-overlay]');
    const sheet = document.querySelector('[data-mds-sort-sheet]');
    if (overlay) overlay.classList.remove('is-open');
    if (sheet) sheet.classList.remove('is-open');
    document.body.style.overflow = '';
  };

  const openFilterDrawer = () => {
    const summary = document.querySelector('.mobile-facets__open-wrapper');
    if (summary) summary.click();
  };

  applyView(initialView);
  applyMobileView(initialMobileView);

  document.addEventListener('click', (event) => {
    const sheetOpen = document.querySelector('.mds-sort-sheet.is-open');
    if (sheetOpen && !event.target.closest('[data-mds-sort-sheet]') && !event.target.closest('[data-mds-mobile-sort-open]')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      closeSortSheet();
      return;
    }
  }, true);

  document.addEventListener('click', (event) => {
    const viewButton = event.target.closest('.mds-view-toggle');
    if (viewButton) {
      event.preventDefault();
      applyView(viewButton.dataset.mdsView);
      return;
    }

    const mobileViewButton = event.target.closest('.mds-mobile-view-toggle');
    if (mobileViewButton) {
      event.preventDefault();
      applyMobileView(mobileViewButton.dataset.mdsMobileView);
      return;
    }

    const sortToggle = event.target.closest('[data-mds-sort-toggle]');
    if (sortToggle) {
      event.preventDefault();
      const sort = sortToggle.closest('[data-mds-sort]');
      const panel = sort?.querySelector('.mds-sort__panel');
      const isOpen = panel && !panel.hidden;
      closeSortPanels();
      if (panel) {
        panel.hidden = isOpen;
        sortToggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      }
      return;
    }

    const sortOption = event.target.closest('[data-mds-sort-option]');
    if (sortOption) {
      event.preventDefault();
      const sort = sortOption.closest('[data-mds-sort]');
      const select = sort?.querySelector('select[name="sort_by"]');
      if (select) {
        select.value = sortOption.dataset.sortValue;
        select.dispatchEvent(new Event('input', { bubbles: true }));
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      sort.querySelectorAll('[data-mds-sort-option]').forEach((button) => {
        const isActive = button === sortOption;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      closeSortPanels();
      return;
    }

    const mobileSortOpen = event.target.closest('[data-mds-mobile-sort-open]');
    if (mobileSortOpen) {
      event.preventDefault();
      openSortSheet();
      return;
    }

    const mobileSortClose = event.target.closest('[data-mds-mobile-sort-close]');
    if (mobileSortClose) {
      event.preventDefault();
      closeSortSheet();
      return;
    }

    const mobileSortOption = event.target.closest('[data-mds-mobile-sort-option]');
    if (mobileSortOption) {
      event.preventDefault();
      const select = document.querySelector('select[name="sort_by"]');
      if (select) {
        select.value = mobileSortOption.dataset.sortValue;
        select.dispatchEvent(new Event('input', { bubbles: true }));
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      document.querySelectorAll('[data-mds-mobile-sort-option]').forEach((button) => {
        const isActive = button === mobileSortOption;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      document.querySelectorAll('[data-mds-sort-option]').forEach((button) => {
        const isActive = button.dataset.sortValue === mobileSortOption.dataset.sortValue;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      closeSortSheet();
      return;
    }

    const filterButton = event.target.closest('[data-mds-open-filters]');
    if (filterButton) {
      event.preventDefault();
      closeSortPanels();
      openFilterDrawer();
      return;
    }

    if (!event.target.closest('[data-mds-sort]')) {
      closeSortPanels();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeSortPanels();
      closeSortSheet();
    }
  });
});
